import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/u539503415/domains/centronics.com.sa/public_html/.builds/source/techsolutions_pro/src/components/common/StickyContactBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageProvider"] */ "/home/u539503415/domains/centronics.com.sa/public_html/.builds/source/techsolutions_pro/src/contexts/LanguageContext.tsx");
;
import(/* webpackMode: "eager" */ "/home/u539503415/domains/centronics.com.sa/public_html/.builds/source/techsolutions_pro/src/styles/index.css");
